/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


/**
 * **Required Permission(s):** ORG_TALENT_REFERRAL_LIST
 */
export const getPendingTalentReferralsResponseItem = zod.object({
  "id": zod.string().uuid(),
  "referringTalentId": zod.string().uuid(),
  "referringTalentFirstName": zod.string().nullish(),
  "referringTalentLastName": zod.string().nullish(),
  "prospect": zod.object({
  "firstName": zod.string(),
  "lastName": zod.string().nullish(),
  "phone": zod.string().nullish(),
  "email": zod.string().nullish()
}),
  "note": zod.string().nullish(),
  "createdDate": zod.string().datetime({})
})
export const getPendingTalentReferralsResponse = zod.array(getPendingTalentReferralsResponseItem)

/**
 * **Required Permission(s):** ORG_TALENT_REFERRAL_INVITE
 */
export const sendTalentReferralInviteParams = zod.object({
  "id": zod.string().uuid()
})

/**
 * **Required Permission(s):** ORG_TALENT_REFERRAL_DENY
 */
export const denyTalentReferralParams = zod.object({
  "id": zod.string().uuid()
})

